import { inject } from 'mobx-react';
import { ChatDrawerButtonComponent } from './component';
export const ChatDrawerButton = inject(({ ui }) => ({
    visible: ui.canUseChat,
}))(ChatDrawerButtonComponent);
//# sourceMappingURL=index.js.map